<template>
  <b-row class="mb-4">
    <b-col cols="12" offset-sm="1" sm="3"></b-col>
    <b-col cols="12" sm="7">
      <b-form-select
        :id="handle"
        v-model="selectedSlug"
        :options="pageOptions"
        @change="handleChange"
      />
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
      <b-form-text v-if="desc" v-html="desc"></b-form-text>
    </b-col>
  </b-row>
</template>

<script>
import GetAllPagesOfProjectById from '@/graphQlQueries/queries/getAllPagesOfProjectBySlugPath';

export default {
  name: 'InternalPageSelectRow',
  props: {
    valueFromDb: { type: String, default: null },
    handle: { type: String, default: null },
    desc: { type: String, default: null },
    projectId: { type: Number, default: null },
    emptyText: { type: String, default: null },
    selectText: { type: String, default: null },
  },
  computed: {
    pageOptions() {
      if (this.pages.length === 0) {
        return [{ value: null, text: this.emptyText }];
      }
      return [
        { value: null, text: this.selectText },
        ...this.pages.map((page) => ({ value: page.slug, text: page.name })),
      ];
    },
  },
  data() {
    return {
      pages: [],
      selectedSlug: null,
    };
  },
  apollo: {
    pages: {
      query: GetAllPagesOfProjectById,
      variables() {
        return {
          projectId: this.projectId,
        };
      },
      update(data) {
        return data?.projects_by_pk?.child_pages || [];
      },
      fetchPolicy: 'network-only',
      skip() {
        return !this.projectId;
      },
    },
  },
  created() {
    this.selectedSlug = this.valueFromDb;
  },
  methods: {
    handleChange(value) {
      this.$emit('update-field', value);
    },
  },
};
</script>
